/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  UserEmailNotificationSetting,
  UserEmailNotificationSettingFromJSON,
  UserEmailNotificationSettingFromJSONTyped,
  UserEmailNotificationSettingToJSON
} from './UserEmailNotificationSetting'

/**
 *
 * @export
 * @interface GetMeEmailNotificationSettingResponseData
 */
export interface GetMeEmailNotificationSettingResponseData {
  /**
   *
   * @type {UserEmailNotificationSetting}
   * @memberof GetMeEmailNotificationSettingResponseData
   */
  userEmailNotificationSetting?: UserEmailNotificationSetting
}

export function GetMeEmailNotificationSettingResponseDataFromJSON(
  json: any
): GetMeEmailNotificationSettingResponseData {
  return GetMeEmailNotificationSettingResponseDataFromJSONTyped(json, false)
}

export function GetMeEmailNotificationSettingResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetMeEmailNotificationSettingResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userEmailNotificationSetting: !exists(json, 'user_email_notification_setting')
      ? undefined
      : UserEmailNotificationSettingFromJSON(json['user_email_notification_setting'])
  }
}

export function GetMeEmailNotificationSettingResponseDataToJSON(
  value?: GetMeEmailNotificationSettingResponseData | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    user_email_notification_setting: UserEmailNotificationSettingToJSON(value.userEmailNotificationSetting)
  }
}
